export const getVisibleState = state => state.dropdown.isVisible
export const getDropdownState = state => state.dropdown
